import React from 'react'
import { LoaderPro } from './loader-styled/LoaderStyled'

const Loader = () => {
    return (
        <LoaderPro>
        </LoaderPro>
    )
}

export default Loader
